<template>
  <div>
    <el-dialog
      append-to-body
      :title="title || '如对当前页面内容做过修改，请先保存后再关闭。'"
      :visible="backDialogVisible"
      width="35%"
      top="40vh"
      :show-close="false"
    >
      <i
        class="fa el-icon-warning mr-1"
        style="color: #E6A23C; font-size: 18px; height: 30px;line-height: 20px;"
      ></i>

      <span style="font-size: 15px; height: 30px;line-height: 30px;">{{
        bodyTitle || '确认关闭当前页面吗'
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" type="primary" size="small">
          {{ $l('INDEX.product_dialog_btn_confirm') || '确定' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'

export default {
  components: {},
  props: {
    backDialogVisible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    bodyTitle: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {}
  },

  methods: {
    cancel() {
      this.$emit('update:backDialogVisible', false)
    },
    close() {
      this.$emit('update:backDialogVisible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}

.el-dialog__header {
  background-color: none;
}
</style>
